import clsx from "clsx";
import "./DoctorModal.scss";
import { BaseModal } from "@/components";
import { DoctorModalContent } from "@/components/ui/DoctorModal/DoctorModalContent";
import { DoctorModalFooter } from "@/components/ui/DoctorModal/DoctorModalFooter";

type DoctorModalProps = {
  open: boolean;
  overrideClassNames?: string;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
  overrideBaseModalClassName?: string;
  role?: string;
};

const DoctorModal = ({
  open,
  overrideClassNames,
  setOpen,
  children,
  overrideBaseModalClassName,
  role,
}: DoctorModalProps) => {
  return (
    <BaseModal
      open={open}
      setOpen={setOpen}
      overrideClassNames={clsx("ui-consent-modal-override", overrideClassNames)}
      overrideBaseModalClassName={overrideBaseModalClassName}
      role={role}
    >
      {children}
    </BaseModal>
  );
};

DoctorModal.Content = DoctorModalContent;
DoctorModal.Footer = DoctorModalFooter;

export { DoctorModal };
